'use strict';
import {buildQueueIdGenerator} from '../../core-utilities/redux/utils';

const prefix = `@@chatMessageQueue`;

export const queueIdGenerator = buildQueueIdGenerator(prefix);



// WEBPACK FOOTER //
// ./src/js/comments/actions/chatMessageQueueActions.js